import every from 'lodash/every';
import React from 'react';
import { Project } from 'records/Project';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface FuncParams {
  hasPerms: boolean;
}

interface Props extends WithAppStoreProps {
  permissions: string[];
  children: (funcParams: FuncParams) => React.ReactNode;
}

interface State {
  hasPerms: boolean;
}

class Permissions extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { selectedProject, projects } = props.appState;

    const { permissions } = projects.get(selectedProject, new Project());

    const hasPerms = every(props.permissions, (perm): boolean =>
      permissions.get(perm, false)
    );

    this.state = {
      hasPerms,
    };
  }

  render(): React.ReactNode {
    return this.props.children({
      hasPerms: this.state.hasPerms,
    });
  }
}

export default withAppStore<Props>(Permissions);
